import { useEffect } from "react";

export default function StorePage() {
  useEffect(() => {
    // Inject Ecwid script dynamically
    const script = document.createElement("script");
    script.src = "https://app.ecwid.com/script.js?110307269&data_platform=code&data_date=2025-04-06";
    script.setAttribute("data-cfasync", "false");
    script.charset = "utf-8";
    script.onload = () => {
      if (window.xProductBrowser) {
        window.xProductBrowser(
          "categoriesPerRow=3",
          "views=grid(20,3) list(60) table(60)",
          "categoryView=grid",
          "searchView=list",
          "id=my-store-110307269"
        );
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="store-page" style={{ padding: "60px 20px" }}>
      <h1 style={{ fontSize: "28px", textAlign: "center", marginBottom: "30px" }}>Shop ChipServer</h1>
      <div id="my-store-110307269"></div>
    </div>
  );
}
